import { Typography } from '@mui/material';
import dayjs from 'dayjs';

export const attendanceViewCroTableHead = ({ setModalState }) => {
  const today = dayjs().date();
  return [
    { field: 'sl_no', headerName: 'Sl No.', width: 120 },
    { field: 'student', headerName: 'Student', width: 200 },
    { field: 'trainer', headerName: 'Trainer', width: 200 },
    { field: 'course', headerName: 'Course', width: 180 },
    // based on date dynamic header
    ...Array.from({ length: today }).map((_, i) => ({
      field: `day_${i + 1}`,
      headerName: `${i + 1}`,
      width: 100,
      renderCell: ({ row, value }) => (
        <Typography
          variant="inherit"
          sx={{
            cursor: 'pointer',
          }}
          onClick={() =>
            setModalState({
              actionKey: 'Daily View',
              row,
            })
          }
        >
          {value}
        </Typography>
      ),
    })),
    //----------------------------
    { field: 'count', headerName: 'Count', width: 100 },
  ];
};

export const dailyViewTableHead = [
  { field: 'sl_no', headerName: 'Sl No.', width: 120 },
  { field: 'date', headerName: 'Date', width: 180 },
  { field: 'from_time', headerName: 'From Time', width: 130 },
  { field: 'to_time', headerName: 'To Time', width: 130 },
  { field: 'subject', headerName: 'Subject', width: 180 },
  { field: 'lessons', headerName: 'Lessons', width: 200 },
  { field: 'remarks', headerName: 'Remarks', width: 220 },
  { field: 'timestamp', headerName: 'Timestamp', width: 180 },
];
